import useEffectiveApplicationId from 'src/hooks/useEffectiveApplicationId';
import { useGetPpaSiteQuery } from 'src/services/switch-rest-api/dashboard.service';
import { isAllSelection } from 'src/utils/selection';
import type { PpaSiteOutput } from 'switch-shared/modules/dashboard/ppa-site.dto';

import type { SolarCardStatus } from '../components/solar/SolarCardState';

export interface PpaSiteData {
  status: SolarCardStatus;

  /** Present once the site has loaded. */
  site?: PpaSiteOutput;
}

/** The selected site's solar performance, fetched once for every widget that reads it. */
const usePpaSiteData = (): PpaSiteData => {
  const appId = useEffectiveApplicationId();
  const hasSite = appId != null && !isAllSelection(appId);

  const { data, isError } = useGetPpaSiteQuery(
    { applicationId: appId ?? '' },
    { skip: !hasSite }
  );

  if (!hasSite) return { status: 'no-site' };
  if (isError) return { status: 'error' };
  if (!data) return { status: 'loading' };
  if (data.meterPoints.solar === 0) return { status: 'no-solar', site: data };
  return { status: 'ready', site: data };
};

export default usePpaSiteData;
